module.exports = __webpack_public_path__ + "img/EG.18f5e988.svg";